import cn from 'classnames';
import React from 'react';

import styles from './slider-arrow.module.scss';

export const SliderArrow: React.FC<{
  className?: string;
  onClick?: () => void;
  icon?: React.ReactNode;
}> = ({ className, onClick, icon }) => (
  <div className={cn(styles.sliderArrow, className)} onClick={onClick}>
    {icon}
  </div>
);
